import React from "react";
import { Flex, Text, SimpleGrid, useMantineTheme } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Filter } from "iconsax-react";
import { IParamsPositionPerformance } from "../../../../hooks";
import { EDiary, EPeriod } from "../../../../interfaces/Filters";
import ModalRangeDate from "../../../../components/PerformanceChart/ModalRangeDate";
import { Select } from "../../../../components";
import MultiSelectProducts from "../../../../components/PerformanceChart/MultiSelectProducts";

interface IProps {
  query: IParamsPositionPerformance;
  setQuery: React.Dispatch<React.SetStateAction<IParamsPositionPerformance>>;
  initialDate: string;
  available_symbols?: string[];
}
export default function FiltersPerformance({
  query,
  setQuery,
  initialDate,
  available_symbols = [],
}: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  const optionsDiary = [
    {
      label: "global.graphic_performance.filters.diary_accumulated",
      value: EDiary.Accumulated,
    },
    {
      label: "global.graphic_performance.filters.diary_daily",
      value: EDiary.Daily,
    },
    {
      label: "global.graphic_performance.filters.diary_accumulated_percentage",
      value: EDiary.AccumulatedPercenteg,
    },
    {
      label: "global.graphic_performance.filters.diary_daily_percentage",
      value: EDiary.DailyPercenteg,
    },
  ];

  const optionsSymbols = [
    {
      label:
        t("global.graphic_performance.filters.symbol_all") ||
        "Todos os símbolos",
      value: "",
    },
    ...(available_symbols?.map((symbol) => ({
      label: symbol,
      value: symbol,
    })) || []),
  ];

  const handleSelectDiary = (value: EDiary) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      diary: value,
      period: EPeriod.All,
    }));
  };

  const handleSelectSymbol = (value: string | null) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      symbols: value && value !== "" ? [value] : undefined,
      period: EPeriod.All,
    }));
  };

  const selectedSymbol =
    query.symbols && query.symbols.length > 0 ? query.symbols[0] : "";

  return (
    <Flex direction={"column"} gap="20px" my="20px">
      <Flex justify="start" align={"center"} gap="8px">
        <Filter size="24" color={theme.colors.basic[5]} />
        <Text fz={{ base: 20 }} lh={{ base: "32px" }} c={theme.colors.basic[5]}>
          {t("global.graphic_performance.filters.title")}
        </Text>
      </Flex>
      <SimpleGrid
        breakpoints={[
          { minWidth: "100", cols: 1 },
          { minWidth: "800", cols: 2 },
          { minWidth: "1200", cols: 3 },
          { minWidth: "1500", cols: 4 },
        ]}
      >
        <ModalRangeDate
          query={query}
          setQuery={setQuery}
          initialDate={initialDate}
        />
        <Select
          data={optionsDiary}
          value={query.diary}
          placeholder={t("global.graphic_performance.filters.diary")}
          label={t("global.graphic_performance.filters.diary")}
          onChange={handleSelectDiary}
          w="100%"
        />
        <Select
          data={optionsSymbols}
          value={selectedSymbol}
          placeholder={
            t("global.graphic_performance.filters.symbol") ||
            "Selecionar símbolo"
          }
          label={t("global.graphic_performance.filters.symbol") || "Símbolo"}
          onChange={handleSelectSymbol}
          w="100%"
          disabled={!available_symbols || available_symbols.length === 0}
        />
        {/* <MultiSelectSymbols
          query={query}
          setQuery={setQuery}
          available_symbols={available_symbols}
        /> */}
        <MultiSelectProducts
          query={query}
          setQuery={setQuery}
          productIdKey="productsId"
        />
      </SimpleGrid>
    </Flex>
  );
}
